import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SettingsService } from '../../../../../shared/services/settings.service';
import { CurrentClientService } from '../../../../../shared/services/current-client.service';

@Component({
    selector: 'app-client-menu',
    templateUrl: './client-menu.component.html',
    styleUrls: ['./client-menu.component.css'],
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive, TranslateModule]
})
export class ClientMenuComponent {

    @Input() clientId: number | null = null;
    @Input() sidebarMode = false;
    @Input() sidebarCollapsed = false;
    @Input() clientType = null;
    @Output() requestExpandSidebar = new EventEmitter<void>();

    public configsOpen = false;
    public configsFlyoutOpen = false;

    constructor(
        public settingsService: SettingsService,
        public currentClientService: CurrentClientService
    ) {}

    public scrollToTop(): void {
        // Segue o padrão de scroll assíncrono usado em outros pontos do app.
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (typeof document === 'undefined') {
                    return;
                }

                const anchor = document.getElementById('page-top-anchor');
                if (anchor && 'scrollIntoView' in anchor) {
                    anchor.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                    return;
                }

                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            });
        });
    }

    public toggleConfigs(event: MouseEvent): void {
        event.preventDefault();
        if (this.sidebarCollapsed) {
            this.requestExpandSidebar.emit();
            this.configsOpen = true;
            return;
        }
        this.configsOpen = !this.configsOpen;
    }
}
